import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMTipoAtividade } from 'src/app/models/crm/crmtipo-atividade';

@Injectable({
  providedIn: 'root'
})
export class CrmtipoAtividadeService {

  constructor(private http: HttpClient) { }

  consultarTiposAtividade() {
    return this.http.get<CRMTipoAtividade[]>(globals.apiUrl + '/api/CRMTipoAtividade/Lista');
  }

  consultarTiposAtividadeComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, statusCadastro) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    if (statusCadastro !== null) {
      parametros = parametros.set('statusCadastro', statusCadastro);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMTipoAtividade/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdTipoAtividade(idTipoAtividade) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMTipoAtividade/Buscar',
      { params: new HttpParams().set('id', idTipoAtividade) });
  }

  salvar(tipoAtividade: CRMTipoAtividade) {
    return this.http.post(globals.apiUrl + '/api/CRMTipoAtividade/Salvar', tipoAtividade);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMTipoAtividade/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}